import React from 'react';
import { Video, ExternalLink } from 'lucide-react';

const ParentTeacherConferences = () => {
  const classroomMeetings = [
    { room: 'K-112', link: 'https://zoom.us/j/96879869769?pwd=iQWGHbMC4RUYVZ2ex1B4R1Gl2RUl7H.1', id: '968 7986 9769', passcode: '735359' },
    { room: 'K-113', link: 'https://zoom.us/j/94484814801?pwd=c42tN2Kl1P8hPM1HuaFpnjWbeVOvoQ.1', id: '944 8481 4801', passcode: '848583' },
    { room: '1-119', link: 'https://zoom.us/j/98147796517?pwd=3sYNOwPjCuCqG8xYLhwn2NA89L0KxN.1', id: '981 4779 6517', passcode: '300953' },
    { room: '1-121', link: 'https://zoom.us/j/96408133748?pwd=b26cB6O2QKQaerykDcFmu0wCRDdMFC.1', id: '964 0813 3748', passcode: '464204' },
    { room: '2-122', link: 'https://zoom.us/j/99442607946?pwd=jAQ8x1vx6k8RdT4WBba9hd6fT0FYw0.1', id: '994 4260 7946', passcode: '123456' },
    { room: '2-124', link: 'https://zoom.us/j/96713001303?pwd=bxko4p90ZoDet6fBexem5FyoUjcFC2.1', id: '967 1300 1303', passcode: '123456' },
    { room: '3-117', link: 'https://zoom.us/j/98937316597?pwd=M218zpaBb3uHxg4w4kgyZXqo7Ljp9z.1', id: '989 3731 6597', passcode: '794538' },
    { room: '3-123', link: 'https://zoom.us/j/94846125451?pwd=I97H1xWGNQNf5fLCUgo9t0BU8Yh7Ok.1', id: '948 4612 5451', passcode: '029155' },
    { room: '3-126', link: 'https://zoom.us/j/96939122993?pwd=NBiSVfQIVWnH23JNr22d55cby8BsLj.1', id: '969 3912 2993', passcode: '415653' },
    { room: '4-210', link: 'https://zoom.us/j/99109090215?pwd=DZK4q4yLo34buxbGMosp4agPdXAsJp.1', id: '991 0909 0215', passcode: '286674' },
    { room: '4-212', link: 'https://zoom.us/j/94462312889?pwd=6fY5w9eAXGkbBVTADOAJPbDXpRj2ic.1', id: '944 6231 2889', passcode: '428346' },
    { room: '571', link: 'https://zoom.us/j/96003423704?pwd=CdVzA42TUZBZtB0q3A3bcg1CYdzxTx.1', id: '960 0342 3704', passcode: '564730' },
    { room: '572', link: 'https://zoom.us/j/93645364869?pwd=naQ1NbwJabYdb93eCPja7zOewf7OQe.1', id: '936 4536 4869', passcode: '799732' },
    { room: '573', link: 'https://zoom.us/j/99370535784?pwd=v90hjwU3gz88jDxknUFojdwL8HHkPm.1', id: '993 7053 5784', passcode: '142078' },
    { room: '640', link: 'https://zoom.us/j/92672774618?pwd=WjmbMVQgk5MKSSOhFd5GZQ3ThBdbOl.1', id: '926 7277 4618', passcode: '045168' },
    { room: '641', link: 'https://zoom.us/j/95560776849?pwd=5YyOEFvtBO5X6b2t3964SnkxcyKIeM.1', id: '955 6077 6849', passcode: '212917' },
    { room: '740', link: 'https://zoom.us/j/98068188498?pwd=jmmUjDBXdI2pj65puSpOBoKmSElCoQ.1', id: '980 6818 8498', passcode: '162297' },
    { room: '741', link: 'https://zoom.us/j/93653157984?pwd=QkWwwMF49HaoJl2rcIjw3QslMMv0Za.1', id: '936 5315 7984', passcode: '770702' },
    { room: '742', link: 'https://zoom.us/j/94933323813?pwd=KO8NMvHuJqn7VnxrfxWi2qF3sb6LEk.1', id: '949 3332 3813', passcode: '695437' },
    { room: '840', link: 'https://zoom.us/j/91271266168?pwd=EjJfl9xXar8vO6pnDiKoyvRFcjfN55.1', id: '912 7126 6168', passcode: '391152' },
    { room: '841', link: 'https://zoom.us/j/93624740503?pwd=L2YRUsB1JT3BU2SJPYo65ryXGb3Fex.1', id: '936 2474 0503', passcode: '841841' },
  ];

  const specialSubjectMeetings = [
    { subject: '5-8 Music (Faulkner)', link: 'https://zoom.us/j/94726799766?pwd=iNGnsqa0oB0iVhDdHkCijRdQRObRTa.1', id: '947 2679 9766', passcode: '008477' },
    { subject: 'Shaw K-4 Music, 5-8 Choir', link: 'https://zoom.us/j/98684212804?pwd=CThmoObtjQwy4Zey6ne41VkakBJzbo.1', id: '986 8421 2804', passcode: '962721' },
    { subject: '5-8 Spanish (Ms. Castaldi)', link: 'https://zoom.us/j/99490650932?pwd=tmfwDiVAfZPKiUpCUC1uybKlFc38W5.1', id: '994 9065 0932', passcode: '354473' },
    { subject: 'K-8 Visual Art', link: 'https://zoom.us/j/91700622476?pwd=AEJbZbK4SbiM7My6U2Zacassa92o5j.1', id: '917 0062 2476', passcode: '979312' },
    { subject: 'K-5 Technology (Ms. Finn)', link: 'https://zoom.us/j/93732830167?pwd=fjaPcosuS99FHf8Iumb9egcdqeRXgE.1', id: '937 3283 0167', passcode: '729470' },
    { subject: '1-8 Physical Education (Wong)', link: 'https://zoom.us/j/92661578540?pwd=SHNuT0eqbb9MqTPGWvGdmwQALInDKa.1', id: '926 6157 8540', passcode: '311804' },
  ];

  const staffMeetings = [
    { staff: 'Erica Arias', link: 'https://zoom.us/j/99285032490?pwd=dCEK4S6gaq7bYuElxPXfQz4k4C55me.1', id: '992 8503 2490', passcode: '664404' },
    { staff: 'Michelle Yrigoyen', link: 'https://zoom.us/j/99002249589?pwd=WN0HULdIE3NC9m6vP5uJKBj7fbb8R2.1', id: '990 0224 9589', passcode: '351451' },
    { staff: '3rd & 4th Grade SETSS (Stanley Wong)', link: 'https://zoom.us/j/98621718932?pwd=sLmuOd2DrV3zGsxQdBaaFYxPwaG4R7.1', id: '986 2171 8932', passcode: '440865' },
    { staff: 'School Counselor (Ms. Burgos)', link: 'https://zoom.us/j/92916879269?pwd=FXzgyxMyMczNybWcxvxaPw1rIRimYG.1', id: '929 1687 9269', passcode: '777166' },
    { staff: 'Ms. Donnah Garcia \u2013 5th & 6th Grade ICT Sp.Ed / Special Education Lead', link: 'https://zoom.us/j/96940474785?pwd=czVLamHZHYXvdLhREq4urvoW7lFvWb.1', id: '969 4047 4785', passcode: '056199' },
  ];

  const renderZoomLink = (link) => {
    if (!link) return <span className="text-secondary-400 italic">&mdash;</span>;
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
      >
        Join Zoom <ExternalLink className="ml-1 h-3.5 w-3.5" />
      </a>
    );
  };

  return (
    <main id="main-content" className="bg-white pt-20">
      {/* Hero Section */}
      <section className="section-padding hero-gradient text-white">
        <div className="container-padding">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-3 bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20 mb-8">
              <Video className="h-5 w-5" />
              <span className="text-sm font-medium tracking-wide uppercase">March 2026</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-light mb-8 leading-tight">
              <span className="block font-extralight text-white/90">Parent-Teacher</span>
              <span className="block font-medium">Conferences</span>
            </h1>

            <p className="text-xl text-white/90 mb-8 font-light max-w-3xl mx-auto leading-relaxed">
              Zoom links for Parent-Teacher Conferences at Talented &amp; Gifted School for Young Scholars (04M012).
            </p>
          </div>
        </div>
      </section>

      {/* Classroom Meetings */}
      <section className="section-padding bg-white">
        <div className="container-padding">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-light text-primary-900 mb-2">
              Classroom Meetings
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full mb-10"></div>

            <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700" tabIndex={0} role="region" aria-label="Classroom meetings table — scroll sideways if it is cut off">
              <table className="w-full text-left">
                <thead>
                  <tr className="bg-primary-50 border-b border-primary-100">
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Room</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Zoom Link</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Meeting ID</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Passcode</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {classroomMeetings.map((meeting, index) => (
                    <tr key={index} className="hover:bg-primary-50/50 transition-colors duration-150">
                      <td className="px-6 py-4 text-sm font-medium text-primary-900">{meeting.room}</td>
                      <td className="px-6 py-4 text-sm">{renderZoomLink(meeting.link)}</td>
                      <td className="px-6 py-4 text-sm text-secondary-700 font-mono">{meeting.id}</td>
                      <td className="px-6 py-4 text-sm text-secondary-700 font-mono">{meeting.passcode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Special Subject Meetings */}
      <section className="section-padding bg-slate-50">
        <div className="container-padding">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-light text-primary-900 mb-2">
              Special Subject Meetings
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full mb-10"></div>

            <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700" tabIndex={0} role="region" aria-label="Special subject meetings table — scroll sideways if it is cut off">
              <table className="w-full text-left">
                <thead>
                  <tr className="bg-primary-50 border-b border-primary-100">
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Subject / Teacher</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Zoom Link</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Meeting ID</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Passcode</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {specialSubjectMeetings.map((meeting, index) => (
                    <tr key={index} className="hover:bg-primary-50/50 transition-colors duration-150">
                      <td className="px-6 py-4 text-sm font-medium text-primary-900">{meeting.subject}</td>
                      <td className="px-6 py-4 text-sm">{renderZoomLink(meeting.link)}</td>
                      <td className="px-6 py-4 text-sm text-secondary-700 font-mono">{meeting.id}</td>
                      <td className="px-6 py-4 text-sm text-secondary-700 font-mono">{meeting.passcode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Staff Meetings */}
      <section className="section-padding bg-white">
        <div className="container-padding">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-light text-primary-900 mb-2">
              Staff Meetings
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full mb-10"></div>

            <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700" tabIndex={0} role="region" aria-label="Staff meetings table — scroll sideways if it is cut off">
              <table className="w-full text-left">
                <thead>
                  <tr className="bg-primary-50 border-b border-primary-100">
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Staff</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Zoom Link</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Meeting ID</th>
                    <th className="px-6 py-4 text-sm font-semibold text-primary-900 uppercase tracking-wider">Passcode</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {staffMeetings.map((meeting, index) => (
                    <tr key={index} className="hover:bg-primary-50/50 transition-colors duration-150">
                      <td className="px-6 py-4 text-sm font-medium text-primary-900">{meeting.staff}</td>
                      <td className="px-6 py-4 text-sm">{renderZoomLink(meeting.link)}</td>
                      <td className="px-6 py-4 text-sm text-secondary-700 font-mono">{meeting.id}</td>
                      <td className="px-6 py-4 text-sm text-secondary-700 font-mono">{meeting.passcode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ParentTeacherConferences;
